import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

const CheckboxContainer = styled.label`
  display: inline-block;
  vertical-align: middle;
`

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 18px;
  height: 18px;
  background: ${props => (props.checked ? 'var(--color-primary)' : '#FFF')};
  border-radius: var(--border-radius-form);
  transition: all 150ms;
  border: 1px solid
    ${props => (props.checked ? 'var(--color-primary)' : 'var(--color-fg)')};

  &:hover {
    border: 1px solid var(--color-primary-hover);
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`

function Checkbox({ className, onChange, ...props }) {
  const [checked, setCheck] = React.useState(false)

  const updateCheck = e => {
    setCheck(e.target.checked)
  }

  React.useEffect(() => {
    setCheck(props.checked)
  }, [props.checked])

  return (
    <CheckboxContainer>
      <HiddenCheckbox
        onChange={e => {
          updateCheck(e)
          return onChange(e)
        }}
        {...props}
      />
      <StyledCheckbox checked={checked} className={className}>
        <Icon viewBox="0 0 25 25">
          <polyline points="23 3 8 18 3 13" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
  )
}

Checkbox.defaultProps = {
  className: '',
  onChange: () => {},
}

Checkbox.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
}

export default Checkbox
